import { connect } from 'react-redux';
import * as Sentry from '@sentry/react';
import { withRouter } from 'react-router';
import { compose, lifecycle } from 'recompose';
import { disconnectWS } from 'modules/websocket/WSManager';
import { updateUser } from 'modules/session/actions/updateUser';
import { getSessionInfo } from 'modules/session/actions/getSessionInfo';
import { sessionInitialized } from 'modules/session/selectors/sessionStatus';
import { fetchOrganizationConfig } from 'modules/common/actions/fetchOrganizationConfig';
import { checkClosestAppointment } from 'modules/queues/common/actions/closestAppointment';
import { onConferencePageMount, onExternalConferencePageMount } from 'modules/queues/common/actions/onConferencePageMount';

import PrivatePage from './PrivatePage';


export default compose(
  withRouter,
  connect(
    (state) => ({
      policyId: state.auth.userInfo.profile.policyId,
      sessionRequestStatus: state.session.sessionInfo.requestStatus,
      isSessionInitialized: sessionInitialized(state),
      firstAppointmentCheckCompleted: state.queues.common.appointmentInfo.firstAppointmentCheckCompleted,
      disconnectWS,
    }),
    {
      getSessionInfo,
      updateUser,
      fetchOrganizationConfig,
      checkClosestAppointment,
      onConferencePageMount,
      onExternalConferencePageMount,
    },
  ),
  lifecycle({
    componentDidMount() {
      const {
        location,
        history,
        getSessionInfo,
        updateUser,
        fetchOrganizationConfig,
        checkClosestAppointment,
        onConferencePageMount,
        onExternalConferencePageMount,
        policyId,
      } = this.props;
      const isReactNative = /RnUmmanu/.test(navigator.userAgent);

      Sentry.configureScope((scope) => {
        scope.setUser({ 'policyId': policyId });
      });

      getSessionInfo()
        .then(updateUser)
        .then(fetchOrganizationConfig)
        .then(() => !isReactNative
          ? checkClosestAppointment(location.search)
          : Promise.resolve(),
        )
        .then(() => !isReactNative
          ? onConferencePageMount(location, history)
          : onExternalConferencePageMount(location, history),
        )
        .catch((err) => console.log('[PrivatePageContainer] Can\'t access to the page', err));
    },

    componentWillUnmount() {
      disconnectWS();
    },
  }),
)(PrivatePage);
